// @ts-nocheck
import { YStack } from 'tamagui';
import { Header } from './Header';
import { Footer } from './Footer';
import { PageFrame } from './PageFrame';

export function PageLayout({ theme, toggleTheme, children }) {
  return (
    <PageFrame>
      <Header theme={theme} toggleTheme={toggleTheme} />
      <YStack flex={1}>{children}</YStack>
      <Footer />
    </PageFrame>
  );
}
